"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giorgio-albanese": {
    "f1acd4b4": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "skipSearch": false
    }],
    "cuccino": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34436280": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "skipSearch": false
    }],
    "lacquani": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "44e4116c": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "skipSearch": false
    }],
    "malfrancati": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f5893f50": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "skipSearch": false
    }],
    "puscino": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "818a4005": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1fcc808d": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "skipSearch": false
    }],
    "scose": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "85e5ddf4": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "skipSearch": false
    }],
    "serra-palazzo": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "66435c8b": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "skipSearch": false
    }],
    "solinari": [{
      "hkey": "8cfa61fa",
      "slug": "san-giorgio-albanese",
      "name": "San Giorgio Albanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;